import React, { FC } from 'react';

import { useGamePolling } from '@nhl/react-hooks/lib/useGamePolling';

import { useGameCenterPlayByPlayQuery, useGameCenterRightRailQuery } from '../../api';
import PlayByPlayDetails from '../../components/playByPlayDetails/PlayByPlayDetails';
import { GameCenterViewType } from '../../enums';
import GameCenterLoader from '../gameCenterLoader/GameCenterLoader';
import RightRail from '../rightRail/RightRail';

import { PlayByPlayContainer } from './styles';

type Props = {
    gameId?: number;
};

const PlayByPlay: FC<Props> = ({ gameId }) => {
    const { data: game, isInitialLoad, refetch } = useGameCenterPlayByPlayQuery(gameId);
    useGamePolling(refetch, [game]);

    const { refetch: refetchRightRail } = useGameCenterRightRailQuery(gameId);
    useGamePolling(refetchRightRail, [game]);

    return (
        <PlayByPlayContainer
            id={`${GameCenterViewType.PLAYBYPLAY}-tabpanel`}
            role="tabpanel"
            aria-labelledby={GameCenterViewType.PLAYBYPLAY}
            $details={game.summary}
        >
            <GameCenterLoader isInitialLoad={isInitialLoad}>
                <PlayByPlayDetails game={game} />
            </GameCenterLoader>
            <RightRail />
        </PlayByPlayContainer>
    );
};

export default PlayByPlay;
